// import intersection from 'lodash/intersection';
import merge from 'lodash/merge';
import getSiteInvalidityMessage from '~lib/common/config/invalidIvSiteMoulageCombos';

function validateIV(caseConf) {
  const errors = [];

  const selectedMoulages = merge(
    {},
    caseConf.moulages,
    caseConf.structuralMoulages
  );

  const iv = caseConf.iv;
  if (iv.enabled) {
    // If IV is on, either dropset or pump must be enabled
    if (!iv.dropSet.enabled && !iv.pump.enabled) {
      errors.push(ivError('If IV is on, either Control Drip Set or Pump must be enabled', 'dropset-or-pump'));
    }

    // If IV Drip Set is on, at least one drip set must be enabled
    if (iv.dropSet.enabled && iv.dropSet.dripSet.length < 1) {
      errors.push(ivError('If IV Drip Set is on, at least one drip set must be enabled', 'dripset'));
    }

    // If IV is on, at least one site must be selected
    const allSites = iv.types.reduce((previous, current) => previous.concat(current.sites), []);
    if (iv.types.length === 0 || allSites.length === 0) {
      errors.push(ivSiteError('If IV is on, at least one site must be enabled', 'ANY', 'ANY'));
    }

    // Validate sites against moulage
    iv.types.forEach(type => {
      type.sites.forEach(site => {
        site.sides.forEach(side => {
          const siteInvalidityMessage = getSiteInvalidityMessage(
            side,
            site.site,
            selectedMoulages
          );
          if (siteInvalidityMessage) {
            errors.push(ivSiteError(siteInvalidityMessage, type.type, site.site, side));
          }
        });
      })
    });

    // Peripheral sites and gauges
    const ivType = iv.types.find(type => type.type === 'PERIPHERAL');
    if (ivType && ivType.sites.length > 0 && ivType.gauges.length === 0) {
      errors.push(ivNeedleError('If peripheral site is enabled, at least one needle gauge must be enabled', ivType.type));      
    }

    // IO sites and gauges
    const ioType = iv.types.find(type => type.type === 'INTRAOSSEOUS');
    if (ioType && ioType.sites.length > 0 && ioType.gauges.length === 0) {
      errors.push(ivNeedleError('If intraosseous site is enabled, at least one needle set must be enabled', ioType.type));      
    }
  }

  return {
    errors,
    warnings: [],
  };
}

function ivError(message, id) {
  return {
    message,
    category: 'ivs',
    field: 'iv',
    id,
    metadata: {      
      scope: 'control',
    },
  };
}

function ivSiteError(message, type, site, side) {
  return {
    message,
    category: 'ivs',
    field: 'iv',
    id: 'site',
    metadata: {
      type,
      site,
      side,
      scope: 'control',
    },
  };
}

function ivNeedleError(message, type) {
  return {
    message,
    category: 'ivs',
    field: 'iv',
    id: 'needle',
    metadata: {
      type,
      scope: 'control',
    },
  };
}

export default validateIV;
